<template>
  <div class="image-text">
    <div v-show="!isEmpty">
      <h2 class="article-title">
        {{ article.title }}
      </h2>
      <p class="article-info">
        {{ pubdate.date + ' ' + pubdate.time + ' ' + article.source }}
      </p>
      <div
        id="container"
        class="article-content"
        v-html="article.content"
      />
    </div>
    <div
      class="emtpy"
      v-show="isEmpty"
    >
      当前未查询到任何数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageText',
  props: {
    article: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    pubdate() {
      if (this.article.pubdate) {
        const arr = this.article.pubdate.slice(0, 10).split('-')
        return { date: arr[0] + '年' + arr[1] + '月' + arr[2] + '日', time: this.article.pubdate.slice(11, 16) }
      }
      return { date: '', time: '' }
    },
    isEmpty() {
      return !this.article || JSON.stringify(this.article) === '{}'
    }
  },
  data() {
    return {}
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.image-text {
  height: calc(100vh - 160px);
  overflow: auto;
  font-size: 12px;
  color: #666;
  padding: 20px 50px;
  font-size: 14px;
  .emtpy {
    text-align: center;
    padding: 50px 0;
    font-size: 13px;
    color: #666;
  }
  .article-title {
    color: #333;
    text-align: center;
    margin-bottom: 9px;
  }
  .article-info {
    text-align: center;
    margin-bottom: 26px;
    font-size: 12px;
  }
  .article-content {
    line-height: 22px;
    text-indent: 2em;
     /deep/ .article-proof-type-error {
        background: #d70d1d !important;
        color: #fff !important;
      }
      /deep/ .article-proof-type-suspicious {
        background: #4497ec !important;
        color: #fff !important;
      }
     /deep/ .errorSelect {
        background: #ffbf00 !important;
        .article-proof-type-error {
        background: #ffbf00 !important;
        color: #fff !important;
      }
      .article-proof-type-suspicious {
        background: #ffbf00 !important;
        color: #fff !important;
      }
      }
  }
}
</style>
